import LoginForm from "@/components/LoginForm/LoginForm";
import ImageComponent from "@/components/LoginForm/ImageComponent";

import "./LoginPage.scss";

export default function LoginPage() {
    return (
        <main className='container_in_loginpage'>
            <LoginForm />
            <ImageComponent />
        </main>
    );
}
